/**
 * Tiny module-scoped counter that locks body scroll while at least one modal
 * is open. Fixes the bug where opening modal B from modal A would capture
 * `body.style.overflow = "hidden"` as the "previous" value and never restore
 * scrolling on close. Always restores to the original value once the counter
 * drops back to 0.
 */
let openCount = 0;
let originalOverflow = "";

export function lockBodyScroll(active) {
    if (typeof document === "undefined") return () => {};
    if (!active) return () => {};
    if (openCount === 0) {
        originalOverflow = document.body.style.overflow || "";
        document.body.style.overflow = "hidden";
    }
    openCount += 1;
    return () => {
        openCount = Math.max(0, openCount - 1);
        if (openCount === 0) {
            document.body.style.overflow = originalOverflow;
            originalOverflow = "";
        }
    };
}
